import { render, staticRenderFns } from "./IbDraggable.vue?vue&type=template&id=641db94a&scoped=true"
import script from "./IbDraggable.vue?vue&type=script&lang=js"
export * from "./IbDraggable.vue?vue&type=script&lang=js"
import style0 from "./IbDraggable.vue?vue&type=style&index=0&id=641db94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641db94a",
  null
  
)

export default component.exports